import { render, staticRenderFns } from "./launcher.vue?vue&type=template&id=459b5c60&"
import script from "./launcher.vue?vue&type=script&lang=js&"
export * from "./launcher.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/buildhome/repo/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('459b5c60')) {
      api.createRecord('459b5c60', component.options)
    } else {
      api.reload('459b5c60', component.options)
    }
    module.hot.accept("./launcher.vue?vue&type=template&id=459b5c60&", function () {
      api.rerender('459b5c60', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/icons/svg/launcher.vue"
export default component.exports